module.exports = __webpack_public_path__ + "static/media/iphone6-3up-dotted.19de7309.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smartphone/iphone6/iphone6-3up-dotted.svg
// module id = 39
// module chunks = 0